export const applyRcngawkRules = (allValues, t) => {
  if (!allValues?.guarantee_package)
    return { corrected: allValues, warnings: [] };

  let corrected = { ...allValues };
  const warnings = [];

  if (corrected.guarantee_package === 'PKG_1' && corrected.turnover > 250000) {
    warnings.push({
      message: t('help.formula1_eligibility_error_title'),
      description: t('help.formula1_eligibility_error'),
      duration: 7,
      key: 'oneTime'
    });
    corrected.guarantee_package = 'PKG_2';
  }

  if (corrected.guarantee_package === 'PKG_2' && corrected.turnover <= 250000) {
    warnings.push({
      message: t('help.formula2_eligibility_error_title'),
      description: t('help.formula2_eligibility_error'),
      duration: 7,
      key: 'oneTime'
    });
    corrected.guarantee_package = 'PKG_1';
  }

  if (
    corrected.guarantee_package === 'PKG_5' &&
    corrected.activity !== 'Convoyeur Automobile'
  ) {
    if (corrected.turnover <= 250000) {
      corrected.guarantee_package = 'PKG_1';
    } else {
      corrected.guarantee_package = 'PKG_2';
    }
    warnings.push({
      message: t('help.formula5_eligibility_error_title'),
      description: t('help.formula5_eligibility_error'),
      duration: 7,
      key: 'oneTime'
    });
  }

  if (corrected.activity === 'Convoyeur Automobile') {
    if (corrected.guarantee_package !== 'PKG_5') {
      warnings.push({
        message: t('help.formula5_mandatory_title'),
        description: t('help.formula5_mandatory_error'),
        duration: 7,
        key: 'oneTime'
      });
      corrected.guarantee_package = 'PKG_5';
    }
    if (corrected.turnover > 250000) {
      warnings.push({
        message: t('help.formula5_turnover_title'),
        description: t('help.formula5_turnover_error'),
        duration: 7,
        key: 'oneTime'
      });
      corrected.turnover = 250000;
    }
  }

  if (
    corrected.turnover > 250000 &&
    corrected.company_status === 'AUTO_ENTREPRENEUR'
  ) {
    corrected.company_status = 'SARL';
  }

  if (corrected.turnover < 1000000) {
    corrected = {
      ...corrected,
      hail_guarantee: false,
      glass_breakage_guarantee: false
    };
  }

  const pkgNum = parseInt(corrected.guarantee_package?.match(/\d+$/)?.[0], 10);
  if (!isNaN(pkgNum)) {
    if (pkgNum < 3 || pkgNum === 5) {
      corrected = {
        ...corrected,
        hail_guarantee: false,
        glass_breakage_guarantee: false,
        theft_guarantee: false,
        fire_guarantee: false,
        damage_all_accidents_guarantee: true,
        third_party_collision_guarantee: false
      };
    } else if (pkgNum === 3) {
      corrected = {
        ...corrected,
        theft_guarantee: true,
        fire_guarantee: true,
        damage_all_accidents_guarantee: true,
        third_party_collision_guarantee: false
      };
    } else {
      corrected = {
        ...corrected,
        theft_guarantee: true,
        fire_guarantee: true,
        damage_all_accidents_guarantee: true,
        third_party_collision_guarantee: true
      };
    }
  }

  return { corrected, warnings };
};
